import * as React from 'react';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';
import Groups from '@material-ui/icons/Group';

interface Props {
	value?: string;
}

const TotalClientsCard = (props: Props) => {
	const { value } = props;
	const translate = useTranslate();
	return (
		<CardWithIcon
			to="/"
			icon={Groups}
			title={translate('TOTAL_CLIENTS')}
			subtitle={value || '---'}
		/>
	);
};

export default TotalClientsCard;
